[
  {
    "code": "MALE",
    "label": {
      "en": "Male",
      "es": "Masculino"
    },
    "order": 1,
    "is_active": true
  },
  {
    "code": "FEMALE",
    "label": {
      "en": "Female",
      "es": "Femenino"
    },
    "order": 2,
    "is_active": true
  },
  {
    "code": "OTHER",
    "label": {
      "en": "Other",
      "es": "Otro"
    },
    "order": 3,
    "is_active": true
  },
  {
    "code": "PREFER_NOT_TO_SAY",
    "label": {
      "en": "Prefer not to say",
      "es": "Prefiero no decir"
    },
    "order": 4,
    "is_active": true
  }
]
